import { Snapshot } from './snapshot.aggregate';
import { snapshotRepositoryImplementation } from '@shared/infrastructure/http/repositories/snapshot/snapshotRepositoryImplementation';

interface SnapshotRepository {
    getSnapshots: (
        countryCode: string
    ) => Promise<Snapshot[]>;
    createSnapshot: (
        countryCode: string,
        name: string
    ) => Promise<Snapshot>;
    restoreSnapshot: (
        countryCode: string,
        snapshotId: number
    ) => Promise<void>;
}

export const snapshotRepository: SnapshotRepository = {
    getSnapshots: (countryCode) => {
        return snapshotRepositoryImplementation.getSnapshots(
            countryCode
        );
    },
    createSnapshot: (countryCode, name) => {
        return snapshotRepositoryImplementation.createSnapshot(
            countryCode, name
        );
    },
    restoreSnapshot: (countryCode, snapshotId) => {
        return snapshotRepositoryImplementation.restoreSnapshot(
            countryCode, snapshotId
        );
    }
};
